import { render } from "./Paginator.vue?vue&type=template&id=7fa8a32f"
import script from "./Paginator.vue?vue&type=script&lang=js"
export * from "./Paginator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/GenericComponents/Paginator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fa8a32f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fa8a32f', __exports__)) {
    api.reload('7fa8a32f', __exports__)
  }
  
  module.hot.accept("./Paginator.vue?vue&type=template&id=7fa8a32f", () => {
    api.rerender('7fa8a32f', render)
  })

}


export default __exports__